import React, { useEffect, useState } from 'react';
import './UmbsInventoryGrid.css';
import BasicCli from '../../../main/components/basicCli/BasicCli';
import EditModal from '../../../main/components/modal/edit/EditModal';
import eFormType from '../../../main/assets/enums/eFormType';
import DeleteModal from '../../../main/components/modal/delete/DeleteModal';
import { ApiConstants } from '../../../main/constants/ApiConstants';
import IUMB from '../../../main/interfaces/IUMB';
import UmbsInventory from '../umbsInventory/UmbsInventory';

import IArea from '../../../main/interfaces/IArea';
import IRow from '../../../main/interfaces/IRow';
import RowsManager from '../../rows/rowsManager/RowsManager';
import axiosInstance from '../../../main/initializers/axios';
import IGridItems from '../../../main/interfaces/IGridItems';
import IPagination from '../../../main/interfaces/IPagination';
import GeneralTable from '../../../main/components/grid/GeneralTable';
import RightPanel from '../../../main/components/rightPanel/RightPanel';
import { useTranslation } from 'react-i18next';

const UmbsInventoryGrid = () => {
  const { i18n } = useTranslation();

  const [umbrellas, setUmbrellas] = useState<IUMB[]>([]);
  
  const [areas, setAreas] = useState<IArea[]>([]);
  const [rows, setRows] = useState<IRow[]>([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isRowShown, setRowShown] = useState(false);
  const [isModalEditOpen, setIsModalEditOpen] = useState(false);
  const [isModalDeleteOpen, setIsModalDeleteOpen] = useState(false);

  const [selectedArea, setSelectedArea] = useState<number>(0);
  const [selectedRowId, setSelectedRowId] = useState<number>(0);
  const [aproved, setAproved] = useState(false);

  const [selectedVal, setSelectedVal] = useState<IUMB | null>(null);
  const [gridItems, setGridItems] = useState<IGridItems[]>([]);
  const [pagination, setPagination] = useState<IPagination>({
    count: 1,
    page: 1,
    itemPerPage: 50,
    itemsPerPage: [10, 20, 50, 100],
  });

  const getRows = () => {
    axiosInstance.get(ApiConstants.row.list + '?rowType=1').then((res) => setRows(res.data));
  };

  const getAreas = () => {
    axiosInstance.get(ApiConstants.area.list).then((res) => setAreas(res.data));
  };

  const selectedItemPagination = (item: IPagination) => {
    setPagination(item);
    getUmbrellas(selectedRowId || 0, item);
  };

  const deleteDataSet = (id: number) => {
    axiosInstance.post(ApiConstants.umb.delete, { id }).then(() => {
      setIsModalDeleteOpen(false);
      setUmbrellas((prev) => prev.filter((el: any) => el.id !== id));
    });
  };

  const handleEdit = (item: IUMB) => {
    setSelectedVal(item);
    setIsModalEditOpen(true);
  };

  const handleDelete = (item: IUMB) => {
    setSelectedVal(item);
    setIsModalDeleteOpen(true);
  };


  const getUmbrellas = (rowId: number | null, pgOverride?: IPagination, gridOverride?: IGridItems[], areaIdOverride?: number) => {
    const pg = pgOverride ?? pagination;
    const effectiveGrid = gridOverride ?? gridItems ?? [];
    const effectiveAreaId = areaIdOverride ?? selectedArea;

    axiosInstance.post(ApiConstants.umb.listct, { gridItems: effectiveGrid, pagination: pg, rowId, areaId: effectiveAreaId }).then((res) => {
      const payload = res.data;

      setUmbrellas(payload.items ?? []);
      setGridItems(payload.gridItems ?? []);

      setPagination({
        ...pg,
        count: payload.pagination?.count ?? pg.count,
        page: payload.pagination?.page ?? pg.page,
        itemPerPage: payload.pagination?.itemPerPage ?? pg.itemPerPage,
      });
    });
  };

  useEffect(() => {
    getRows();
    getAreas();
    getUmbrellas(0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleRowFilterChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const id = Number(event.target.value);
    setSelectedRowId(id);
    const nextPagination = { ...pagination, page: 1 };
    setPagination(nextPagination);
    getUmbrellas(id, nextPagination, undefined, selectedArea);
  };

  const handleAreaFilterChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const id = Number(event.target.value);
    setSelectedArea(id);
    const nextPagination = { ...pagination, page: 1 };
    setPagination(nextPagination);
    getUmbrellas(selectedRowId || 0, nextPagination, undefined, id);
  };

  return (
    <BasicCli>
      <div className="uigPage">
        <div className="uigContainer">
          {/* Toolbar uses theme.css primitives */}
          <div className="ui-panel ui-toolbar uigToolbar">
            <div className="uigRowFilter">
              <select className="ui-control ui-select" value={selectedArea} onChange={handleAreaFilterChange} aria-label="Filter by area">
                <option value={0}> {i18n.t('area.chooseArea')} </option>
                {areas.map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.name}
                  </option>
                ))}
              </select>
              <select className="ui-control ui-select" value={selectedRowId} onChange={handleRowFilterChange} aria-label="Filter by row">
                <option value={0}> {i18n.t(`generic.-select-`)} </option>
                {rows.map((item, index) => (
                  <option key={index} value={item.id}>
                    {item.name}
                  </option>
                ))}
              </select>
            </div>

            <div className="uigActions">
              <button type="button" className="ui-control ui-btn ui-btn--primary" onClick={() => setIsModalOpen(true)}>
                {i18n.t(`generic.addUmbrella`)}
              </button>

              <button type="button" className="ui-control ui-btn ui-btn--primary" onClick={() => setRowShown((s) => !s)}>
                {i18n.t(`generic.addRows`)}
              </button>
            </div>
          </div>

          <RightPanel isOpen={isRowShown} size={50} type="right" onKill={() => setRowShown((s) => !s)} backdropClicked={() => setRowShown((s) => !s)}>
            <RowsManager header={i18n.t(`generic.rows`)} isOrder={false} handleClick={() => getRows()} rowType={1} />
          </RightPanel>

          <div className="uigTable">
            <GeneralTable
              data={umbrellas}
              columns={gridItems}
              gridEntity={5}
              title=""
              hasRp
              selectedItem={(val) => setSelectedVal(val)}
              onEdit={handleEdit}
              onDelete={handleDelete}
              pagination={pagination}
              selectedItemPagination={(val: any) => selectedItemPagination(val)}
              onFilterClose={(nextGridItems) => {
                setGridItems(nextGridItems);
                getUmbrellas(selectedRowId || 0, undefined, nextGridItems);
              }}
            />
          </div>

          {isModalEditOpen && (
            <EditModal
              title={i18n.t('generic.editUmbrella')}
              width="1024px"
              closeModal={() => setIsModalEditOpen(false)}
              onSubmitData={() => setAproved(true)}
              setIsModalOpen={setIsModalEditOpen}
              modalType={eFormType.Edit}
            >
              <UmbsInventory
                tempProduct={selectedVal}
                rows={rows}
                areas={areas}
                createOrUpdate={aproved}
                modalType={eFormType.Edit}
                onSubmitData={() => {
                  setIsModalEditOpen(false);
                  getUmbrellas(selectedRowId || 0);
                  setAproved(false);
                }}
              />
            </EditModal>
          )}

          {isModalDeleteOpen && (
            <DeleteModal width="500px" handleClose={() => setIsModalDeleteOpen(false)} handleDelete={() => deleteDataSet(selectedVal?.id ?? 0)}>
              {i18n.t('generic.wantToDelete')} <strong className="uigDangerText">{selectedVal?.name}</strong> {i18n.t('generic.code')} (
              {selectedVal?.code}).
            </DeleteModal>
          )}

          {isModalOpen && (
            <EditModal
              title={i18n.t(`generic.addUmbrella`)}
              width="80%"
              closeModal={() => setIsModalOpen(false)}
              onSubmitData={() => setAproved(true)}
              setIsModalOpen={setIsModalOpen}
              modalType={eFormType.New}
            >
              <UmbsInventory
                rows={rows}
                areas={areas}
                createOrUpdate={aproved}
                modalType={eFormType.New}
                onSubmitData={() => {
                  setAproved(false);
                  setIsModalOpen(false);
                  getUmbrellas(selectedRowId || 0);
                }}
              />
            </EditModal>
          )}
        </div>
      </div>
    </BasicCli>
  );
};

export default UmbsInventoryGrid;
